import { Injectable } from '@angular/core';
import { config } from '@tag/graphql';
import type { GraphQLParams, OutsideServiceProvider } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';

export interface Response {
  outsideServiceProviders: {
    items: OutsideServiceProvider[];
    totalCount: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class OutsideServiceProvidersGQL extends Query<
  Response,
  GraphQLParams<'outsideServiceProvider'>
> {
  document = gql(config.outsideServiceProvider.query);
}
